// NOTE: set "eager" mode for globally-used modules:
export const map = {
  /* eslint-disable @typescript-eslint/naming-convention */
  AvatarButton: () => import(/* webpackMode: "eager" */ "./components/header/AvatarButton"),
  PostButton: () => import(/* webpackMode: "eager" */ "./components/header/PostButton"),
  PostButtonSP: () => import(/* webpackMode: "eager" */ "./components/header/PostButtonSP"),
  NotificationCenter: () => import(/* webpackMode: "eager" */ "./components/notification_center/NotificationCenter"),
  AnnounceBox: () => import(/* webpackMode: "eager" */ "./components/AnnounceBox"),
  Toast: () => import(/* webpackMode: "eager" */ "./components/shared/toast"),
  HeaderNavigationSearch: () => import(/* webpackMode: "eager" */ "./components/search/HeaderNavigationSearch"),
  ActivityMeter: () => import("./components/shared/ActivityMeter"),
  GroupCreateButton: () => import("./components/GroupCreateButton"),
  FeedGroupList: () => import("./components/feed_group_list/FeedGroupList"),
  GroupListContainer: () => import("./components/group_list/GroupListContainer"),
  NoteVersionItems: () => import("./components/entry/NoteVersionItems"),
  GroupLabel: () => import("./components/GroupsLabel"),
  FeedEntryIcon: () => import("./components/shared/feed_entry_icon"),
  DashboardEditorContainer: () => import("./components/DashboardEditorContainer"),
  AvatarSettingForm: () => import("./components/setting/AvatarSettingForm"),
  MultiFactorAuthnSettingContainer: () => import("./components/mfa/SettingContainer"),
  MfaEnforceContainer: () => import("./components/mfa_enforce/MfaEnforceContainer"),
  PlanChangingForm: () => import("./components/PlanChangingForm"),
  RegistrationFormContainer: () => import("./components/registration/registration_form_container"),
  NoteTemplateEditorContainer: () => import("./components/noteTemplateEditor/NoteTemplateEditorContainer"),
  NoteTemplateFoldersContainer: () => import("./components/noteTemplateFolders/NoteTemplateFoldersContainer"),
  FolderContainer: () => import("./components/folder/FolderContainer"),
  OutgoingWebhookDropdownButton: () => import("./components/outgoing_webhook/outgoing_webhook_dropdown_button"),
  Presentation: () => import("./components/presentation/Presentation"),
  InvitationButton: () => import("./components/invitation/InvitationButton"),
  UserCoverImageForm: () => import("./components/setting/UserCoverImageForm"),
  Feed: () => import("./components/feed/Feed"),
  ProfilePage: () => import("./components/ProfilePage"),
  DeleteTeamForm: () => import("./components/delete_team/DeleteTeamForm"),
  ImporterUserList: () => import("./components/ImporterUserList"),
  UserAvatars: () => import("./components/shared/UserAvatars"),
  NotificationSettingSwitch: () => import("./components/setting/NotificationSettingSwitch"),
  SharedEntrySettingSwitch: () => import("./components/shared_entry/SharedEntrySettingSwitch"),
  SharedEntryActionBar: () => import("./components/shared_entry/SharedEntryActionBar"),
  SharedEntryToggleFullWidth: () => import("./components/shared_entry/SharedEntryToggleFullWidth"),
  UpdateTeamForm: () => import("./components/update_team/UpdateTeamForm"),
  FeedRightSideBar: () => import("./components/feed/FeedRightSideBar"),
  ContributorsLabel: () => import("./components/ContributorsLabel"),
  ContributorsTextLabel: () => import("./components/ContributorsTextLabel"),
  EditorContainer: () => import("./components/editor/EditorContainer"),
  FolderIndicator: () => import("./components/FolderIndicator"),
  UserListInManageMembers: () => import("./components/manage_members/UserListInManageMembers"),
  NoteToc: () => import("./components/note/NoteToc"),
  UserAvatarsWithOverflowIcon: () => import("./components/UserAvatarsWithOverflowIcon"),
  NoteHeader: () => import("./components/note/NoteHeader"),
  NotePage: () => import("./components/NotePage"),
  ReviewableDraftContainer: () => import("./components/reviewable_draft/ReviewableDraftContainer"),
  ReviewableDraftCommentsContainer: () => import("./components/reviewable_draft/ReviewableDraftCommentsContainer"),
  ReviewableDraftActionBar: () => import("./components/reviewable_draft/ReviewableDraftActionBar"),
  CopyableText: () => import("./components/CopyableText"),
  AccessTokenListContainer: () => import("./components/access_token/AccessTokenListContainer"),
  AccessTokenContainer: () => import("./components/access_token/AccessTokenContainer"),
  AccessTokenLogListContainer: () => import("./components/access_token_log/AccessTokenLogListContainer"),
  TeamSettingFormContainer: () => import("./components/TeamSettingFormContainer"),
  BillingMethodUpdatingForm: () => import("./components/BillingMethodUpdatingForm"),
  SearchFilterContainer: () => import("./components/search/SearchFilterContainer"),
  OutgoingWebhookSwitcher: () => import("./components/setting/OutgoingWebhookSwitcher"),
  PlanDowngradingForm: () => import("./components/PlanDowngradingForm"),
  UserNotificationSettingSwitchButton: () => import("./components/UserNotificationSettingSwitchButton"),
  CustomEmojiContainer: () => import("./features/emoji"),
  GroupManageContainer: () => import("./components/group_manage/GroupManageContainer"),
  OtherNWithUserListPanel: () => import("./components/shared/OtherNWithUserListPanel"),
  CollaborationIconWithTooltip: () => import("./components/shared/CollaborationIconWithTooltip"),
  UserAvatarWithPopup: () => import("./components/shared/UserAvatarWithPopup"),
  UserFeatureSwitchButton: () => import("./components/UserFeatureSwitchButton"),
  SearchResults: () => import("./components/search/searchResults"),
  SearchResultsForFolder: () => import("./components/search/SearchResultsForFolder"),
  ImportersTabs: () => import("./components/importers/ImportersTabs"),
  SSOTabs: () => import("./components/sso/SSOTabs"),
  SearchSort: () => import("./components/search/SearchSort"),
  SearchTargetModel: () => import("./components/search/SearchTargetModel"),
  AssistantContainer: () => import("./components/assistants/AssistantContainer"),
  Saml2SsoSetting: () => import("./components/setting/Saml2SsoSetting"),
  AuditLogRoleFilter: () => import("./components/auditLog/AuditLogRoleFilter"),
  AuditLogOrderSelector: () => import("./components/auditLog/AuditLogOrderSelector"),
  MemberFilters: () => import("./components/manage_members/MemberFilters"),
  AssistantWindow: () => import("./components/assistants/AssistantWindow"),
  SearchFilterSetContainer: () => import("./components/search/SearchFilterSetContainer"),
  UploadedFiles: () => import("./components/setting/UploadedFiles"),
  /* eslint-enable @typescript-eslint/naming-convention */
};
